<template>
  <div class='comtent'>
    <div class="ma-text">{{ $t('content17') }}</div>
    <div class="bo-text">{{ $t('content18') }}</div>

    <!-- <div class="btn-box">
      <div class="btn-blue">预约演示</div>
      <div class="btn-we">参观一下</div>
    </div> -->

    <!-- <div class="bg-1">
      <img src="@/assets/img_91.png" class="bg-img" alt="">
      <div class="img-text-box">
        <img src="@/assets/img_01.png" class="bg-img-1" alt="">
        <div class="bg-box-text">273927.00 USD</div>
      </div>
    </div> -->
    <div class="bg-1">
      <img v-if="$i18n.locale == 'zh'" src="@/assets/img_609.png" class="bg-img" alt="">
      <img v-else src="@/assets/en_img_3.png" class="bg-img" alt="">
      <div class=" animated-box">
        <img v-if="$i18n.locale == 'zh'" src="@/assets/img_01.png" class="bg-img-1" alt="">
        <img v-else src="@/assets/en_img_2.png" class="bg-img-1" alt="">
        <div class="bg-box-text">28.00 USD</div>
      </div>
      <div class="bg-img-2-container">
        <img src="@/assets/img_111.png" class="bg-img-2" alt="">
      </div>
      <div class="bg-img-3-container">
        <img v-if="$i18n.locale == 'zh'" src="@/assets/Frame 468@2x.png" class="bg-img-3" alt="">
        <img v-else src="@/assets/en_img_0.png" class="bg-img-3" alt="">
      </div>
      <!-- <div class='img-icon-box'>
        <img src="@/assets/img_0.png" class="bg-img-icon" alt="">
      </div>
      <div class='img-icon-box1'>
        <img src="@/assets/img_3.png" class="bg-img-icon1" alt="">
      </div>
      <div class='img-icon-box2'>
        <img src="@/assets/img_1.png" class="bg-img-icon2" alt="">
      </div>
      <div class='img-icon-box3'>
        <img src="@/assets/img_3.png" class="bg-img-icon3" alt="">
      </div>
      <div class='img-icon-box4'>
        <img src="@/assets/img_2.png" class="bg-img-icon4" alt="">
      </div>
      <div class='img-icon-box5'>
        <img src="@/assets/img_3.png" class="bg-img-icon5" alt="">
      </div> -->
    </div>
    <div class="earth-box">
      <img src="@/assets/bg2.png" class="bg-2" alt="">
      <div :class="$i18n.locale + '_text-font'">{{ $t('content19') }}</div>
      <img v-if="img5" :src="$i18n.locale == 'zh' ? require('@/assets/img_pay9.png') : require('@/assets/en_img_9.png')"
        class="bg-10" :class="{
          'pulse-animate': animateBg10,
          'sweet-potato-animation': sweetPotatoBg10,
          'fade-out-animation': showFadeOutBg10
        }" alt="">
      <div class="new-white-box" :class="{
        'show': showNewWhiteBox,
        'slide-and-fade': slideAndFadeWhiteBox
      }">
        <img src="@/assets/img_52.png" class="bg-img-6" alt="">
        <img src="@/assets/img_101.png" class="bg-img-7" alt="">
        <div class="white_text" :class="$i18n.locale + '_white_text'">{{ $t('content20') }}</div>
        <div class="white_number">40.00 USD</div>
        <img :src="$i18n.locale == 'zh' ? require('@/assets/img_46.png') : require('@/assets/en_img_r.png')" class="bg-img-8"
          alt="">
        <!-- <img src="@/assets/img_09.png" class="bg-img-9" alt=""> -->
      </div>
      <img :src="$i18n.locale == 'zh' ? require('@/assets/img_9.png') : require('@/assets/en_img_7.png')" class="bg-9"
        v-if="sweetPotatoBg11" :class="{ 'pulse-animate': animateBg9 }" alt="">
      <img src="@/assets/img_610.png" class="bg-19" alt="">
      <div class='text-12' v-if="showText">
        <span class="typing-text" :class="{ 'pulse-text': pulseBg12 }">
          {{ displayText12 }}
        </span>
      </div>
      <div class='text-13' v-if="showText">
        <span class="typing-text" :class="{ 'pulse-text': pulseBg13 }">
          {{ displayText13 }}
        </span>
      </div>
      <div :class="{ 'show-slide': showBgImg4 }" v-if="img4">
        <img src="@/assets/img_09.png" class="bg-img-4" alt="">
        <img src="@/assets/img_pay8.png" :class="$i18n.locale + '_bg-img-5'" alt="">

      </div>
    </div>

    <div>
      <div class="text-font-bottom">{{ $t('content21') }}</div>
      <div class="bo-text">{{ $t('content22') }}</div>
      <div class="img-box">
        <div class="flex-img-text" :class="{ actives: colorMiddle == 0 }" @click="cliColor(0)">
          <img v-if="colorMiddle != 0" src="@/assets/pay1.png" class="con-1" alt="">
          <img v-else src="@/assets/pay2.png" class="con-1" alt="">
          <div class="text-color">{{ $t('content23') }}</div>
        </div>
        <div class="flex-img-text" :class="{ actives: colorMiddle == 1 }" @click="cliColor(1)">
          <img v-if="colorMiddle != 1" src="@/assets/loop1.png" class="con-2" alt="">
          <img v-else src="@/assets/loop2.png" class="con-2" alt="">
          <div class="text-color">{{ $t('content24') }}</div>
        </div>
        <div class="flex-img-text" :class="{ actives: colorMiddle == 2 }" @click="cliColor(2)">
          <img v-if="colorMiddle != 2" src="@/assets/api1.png" class="con-3" alt="">
          <img v-else src="@/assets/api2.png" class="con-3" alt="">
          <div class="text-color">API</div>
        </div>
        <div class="flex-img-text" :class="{ actives: colorMiddle == 3 }" @click="cliColor(3)">
          <img v-if="colorMiddle != 3" src="@/assets/safety1.png" class="con-4" alt="">
          <img v-else src="@/assets/safety2.png" class="con-4" alt="">
          <div class="text-color">{{ $t('content25') }}</div>
        </div>
      </div>
      <div :class="$i18n.locale + '_box548'" v-show="colorMiddle == 0">
        <div :class="$i18n.locale + '_text-boxs'">
          <div class="con-5">{{ $t('content26') }}</div>
          <div class="con-6">{{ $t('content27') }}
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-7" alt="">
            <div class="con-8">{{ $t('content28') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-7" alt="">
            <div class="con-8">{{ $t('content29') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-7" alt="">
            <div class="con-8">{{ $t('content30') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-7" alt="">
            <div class="con-8">{{ $t('content31') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-7" alt="">
            <div class="con-8">{{ $t('content32') }}</div>
          </div>
        </div>

        <div :class="$i18n.locale + '_right-box'">
          <img
            :src="$i18n.locale == 'zh' ? require('@/assets/duandaoduan_zhifu_img@2x.png') : require('@/assets/en_duandaoduan_zhifu_img.png')"
            :class="$i18n.locale + '_right-img'" alt="">
        </div>
      </div>

      <div :class="$i18n.locale + '_box548'" v-show="colorMiddle == 1">
        <div :class="$i18n.locale + '_text-boxs'">
          <div class="con-9">{{ $t('content33') }}</div>
          <div class="con-10">
            {{ $t('content34') }}
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content35') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content36') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content37') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content38') }}</div>
          </div>
        </div>

        <div :class="$i18n.locale + '_right-box'">
          <img
            :src="$i18n.locale == 'zh' ? require('@/assets/duandaoduan_xitong_img@2x.png') : require('@/assets/en_duandaoduan_xitong_img.png')"
            :class="$i18n.locale + '_box-img-1'" alt="">
        </div>
      </div>

      <div :class="$i18n.locale + '_box548'" v-show="colorMiddle == 2">
        <div :class="$i18n.locale + '_text-boxs'">
          <div class="con-5">{{ $t('content39') }}</div>
          <div class="con-6">
            {{ $t('content40') }}
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content41') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content42') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content43') }}</div>
          </div>
        </div>

        <div :class="$i18n.locale + '_right-box'">
          <img
            :src="$i18n.locale == 'zh' ? require('@/assets/duandaoduan_api_img@2x.png') : require('@/assets/en_duandaoduan_api_img.png')"
            :class="$i18n.locale + '_box-img-1'" alt="">
        </div>
      </div>

      <div :class="$i18n.locale + '_box548'" v-show="colorMiddle == 3">
        <div :class="$i18n.locale + '_text-boxs'">
          <div class="con-5">{{ $t('content44') }}</div>
          <div class="con-6">
            {{ $t('content45') }}
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content46') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content47') }}</div>
          </div>
          <div class="yes-flex">
            <img src="@/assets/yes1.png" class="con-4" alt="">
            <div class="con-8">{{ $t('content48') }}</div>
          </div>
        </div>

        <div :class="$i18n.locale + '_right-box'">
          <img
            :src="$i18n.locale == 'zh' ? require('@/assets/duandaoduan_anquan_img@2x.png') : require('@/assets/en_duandaoduan_anquan_img.png')"
            :class="$i18n.locale + '_box-img-1'" alt="">
        </div>
      </div>
    </div>
    <div class="con-11">
      <div class="con-12">
        <img :src="$i18n.locale == 'zh' ? require('@/assets/apilianjie_img@2x.png') : require('@/assets/en_Frame 300.png')"
          class="con-12-img" alt="">
      </div>
      <div class="con-13">
        <div class="con-14">{{ $t('content49') }}</div>
        <div class="con-15">{{ $t('content50') }}
        </div>
      </div>
    </div>

    <div class="earth-box">
      <img src="@/assets/bg3@2x.png" alt="" :class="$i18n.locale + '_con-16'">
      <div class="con-17">
        {{ $t('content51') }}</div>
      <div class="con-18">
        {{ $t('content52') }}</div>

      <div class="linBox-res">
        <div class="linBox1">
          <div :class="$i18n.locale + '_con-19'">{{ $t('content53') }}</div>
          <div class="con-20" :class="$i18n.locale + '_con-20'"> <img src="@/assets/Slice 24@2x.png" class="con-20-img"
              alt="">
          </div>
          <div class="con-21">
            <img src="@/assets/feiyong_icon@2x.png" class="con-21-img" alt="">
            <div class="con-22">{{ $t('content54') }}</div>
          </div>
        </div>
        <div class="linBox1">
          <div :class="$i18n.locale + '_con-23'">90</div>
          <div :class="$i18n.locale + '_con-24'"> <img src="@/assets/Slice 24@2x.png" class="con-20-img" alt="">
            <div class="con-25">%</div>
          </div>
          <div class="con-21">
            <img src="@/assets/feiyong_icon@2x.png" class="con-21-img" alt="">
            <div class="con-22">{{ $t('content55') }}</div>
          </div>
        </div>
        <div class="linBox1">
          <div :class="$i18n.locale + '_con-23'">75</div>
          <div :class="$i18n.locale + '_con-24'"> <img src="@/assets/Slice 24@2x.png" class="con-20-img" alt="">
            <div class="con-25">%</div>
          </div>
          <div class="con-21">
            <img src="@/assets/feiyong_icon@2x.png" class="con-21-img" alt="">
            <div class="con-22">{{ $t('content56') }}</div>
          </div>
        </div>
      </div>
      <img v-if="$i18n.locale == 'zh'" src="@/assets/imgFrame 303@2x.png" class="con-26" alt="">
      <img v-else src="@/assets/en_zhichi_img@2x.png" class="con-26" alt="">
    </div>

    <div class="bottom-box">
      <div class="bottom-min-box">
        <div :class="$i18n.locale + '_bottom-left-box'">
          <div class="bottom-text-36">{{ $t('content57') }}</div>
          <div class="bottom-text-18">{{ $t('content195') }}</div>
        </div>
        <div class="bottom-right-box">
          <div class="box-app">
            <img src="@/assets/Whatsapp_icon@2x.png" class="con-33" alt="">
            <div class="con-34">Whatsapp</div>
            <div class="con-35"></div>
            <div class="con-36">
              <div class="contact-QRCode">
                <img src="@/assets/appicon.png" class="QRCode" alt="">
              </div>
            </div>
          </div>
          <div class="box-wx">
            <img src="@/assets/weixin_icon@2x.png" class="con-33" alt="">
            <div class="con-34">{{ $t('content58') }}</div>
            <div class="con-35"></div>
            <div class="con-36">
              <div class="contact-QRCode">
                <img src="@/assets/wx_img2.jpg" class="QRCode" alt="">
              </div>
            </div>
          </div>
          <div class="box-ml">
            <img src="@/assets/youxiang_icon@2x.png" class="con-33" alt="">
            <div class="con-34">{{ $t('content15') }}</div>
            <div class="con-37"></div>
            <div class="con-36">uxpay@uxpay.com</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import
export default {
  name: 'homePage',
  components: {

  },
  data() {
    return {
      colorMiddle: 0,
      displayNumber: '1.02',
      startNumber: 1.02,
      targetNumber: 46.00,
      animationActive: false,
      showIconBox: false,
      displayText12: '',
      displayText13: '',
      showText: false,
      showBgImg4: false,
      animateBg9: false,
      animateBg10: false,
      img4: false,
      pulseBg12: false,
      pulseBg13: false,
      sweetPotatoBg10: false,
      sweetPotatoBg11: false,
      showFadeOutBg10: false,
      showNewWhiteBox: false,
      img5: true,
      slideAndFadeWhiteBox: false

    };
  },
  computed: {

  },
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.startNumberAnimation()
    this.triggerIconBoxAnimation()
    this.startTextAnimation()
    // this.startImageAnimations()
  },
  methods: {
    cliColor(index) {
      this.colorMiddle = index

    },
    startNumberAnimation() {
      if (this.animationActive) return

      this.animationActive = true
      let currentNumber = this.startNumber
      const step = (this.targetNumber - this.startNumber) / 15 // 25 steps for smoother transition
      const animateNumber = () => {
        // Generate a random number closer to the target
        setTimeout(() => {
          currentNumber += Math.abs(step) + Math.random() * 6
        }, 2000)
        // Ensure we don't go below the target number
        if (currentNumber >= this.targetNumber) {
          currentNumber = this.targetNumber
        }
        // Update the display
        this.displayNumber = currentNumber.toFixed(2)

        // Continue animation if not reached target
        if (currentNumber < this.targetNumber) {
          requestAnimationFrame(animateNumber)
        } else {
          // Reset for next cycle after a delay
          setTimeout(() => {
            this.animationActive = false
            this.startNumberAnimation()
          }, 3000)
        }
      }

      // Start the animation
      requestAnimationFrame(animateNumber)
    },
    triggerIconBoxAnimation() {
      // 在图片动画结束后显示图标
      setTimeout(() => {
        this.showIconBox = true
      }, 3000) // 根据动画总时长调整
    },
    typeText(text, callback) {
      let index = 0;
      const typeWriter = () => {
        if (index < text.length) {
          this.displayText12 = text.slice(0, index + 1)
          index++
          setTimeout(typeWriter, 200) // 每个字符间隔100ms
        } else {
          callback && callback()
        }
      }
      typeWriter()
    },
    typeText2(text) {
      let index = 0
      const typeWriter = () => {
        if (index < text.length) {
          this.displayText13 = text.slice(0, index + 1)
          index++
          setTimeout(typeWriter, 200) // 每个字符间隔100ms
        }
      }
      typeWriter()
    },
    startTextAnimation() {
      this.sweetPotatoBg10 = true
      setTimeout(() => {
        this.sweetPotatoBg11 = true
      }, 1000)

      setTimeout(() => {
        this.showText = true
        this.typeText('40.00', () => {
          // 第一个文本打完后，开始第二个
          setTimeout(() => {
            this.typeText2('53.844')
            this.img4 = true
            if (this.img4) {
              setTimeout(() => {
                this.showBgImg4 = true

                this.animateBg9 = true
                this.animateBg10 = true
                this.showText = false
                this.img5 = false

                // 整个动画序列结束后重新开始
                setTimeout(() => {
                  this.resetAnimationState()
                  this.startTextAnimation()
                  this.typeText12 = ''
                  this.typeText13 = ''
                }, 3000) // 根据整个动画周期调整时间
              }, 2000)

              setTimeout(() => {
                this.showFadeOutBg10 = true

                setTimeout(() => {
                  this.showNewWhiteBox = true
                }, 800)

                setTimeout(() => {
                  this.slideAndFadeWhiteBox = true
                }, 3000)
              }, 1000)

              setTimeout(() => {
                this.triggerTextPulse()
                this.sweetPotatoBg11 = false
                this.img4 = false
              }, 1100)
            }
          }, 500)
        })
      }, 2000)
    },

    resetAnimationState() {
      // 重置所有状态，准备下一个循环
      this.showText = false
      this.img4 = false
      this.img5 = true
      this.showBgImg4 = false
      this.animateBg9 = false
      this.animateBg10 = false
      this.showFadeOutBg10 = false
      this.showNewWhiteBox = false
      this.slideAndFadeWhiteBox = false
      this.sweetPotatoBg10 = false
      this.sweetPotatoBg11 = true
      this.pulseBg12 = false
      this.pulseBg13 = false
    },
    triggerTextPulse() {
      // 确保动画触发
      this.pulseBg12 = true
      this.pulseBg13 = true

      // 额外的强制重绘
      this.$nextTick(() => {
        const text12 = document.querySelector('.text-12 .typing-text')
        const text13 = document.querySelector('.text-13 .typing-text')

        if (text12) {
          text12.classList.add('pulse-text')
          void text12.offsetWidth // 触发重绘
        }

        if (text13) {
          text13.classList.add('pulse-text')
          void text13.offsetWidth // 触发重绘
        }
      })
    }

  }
}
</script>
<style scoped>
.comtent {
  padding: 0 auto;
  margin: 0 auto;
  overflow: hidden;
}

@keyframes sweet-potato-drop {
  0% {
    transform: translateY(-100%) rotate(-15deg);
    opacity: 0;
  }

  70% {
    transform: translateY(10%) rotate(5deg);
    opacity: 0.7;
  }

  100% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
}

.bg-10.sweet-potato-animation {
  animation:
    sweet-potato-drop 1.2s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
}

.ma-text {
  font-size: 36px;
  margin-top: 87px;
  text-align: center;

}

.animated-box {
  width: 300px;
  height: 178px;
  display: flex;
  align-items: center;
  gap: 10px;
  position: absolute;
  top: 350px;
  left: 245px;
  z-index: 99 !important;
  animation: slideAnimation 5s ease-in-out infinite;
}

@keyframes slideAnimation {

  0%,
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }

  20%,
  80% {
    transform: translateX(0);
    opacity: 1;
  }
}

.bo-text {
  font-size: 22px;
  margin-top: 18px;
  text-align: center;
  color: #666666;
}

.con-21 {
  display: flex;
  align-items: center;
  position: absolute;
  left: 50px;
  top: 148px;
}

.con-22 {
  color: #666666;
  font-size: 24px;
  padding-left: 10px;
}

.zh_con-23 {
  font-size: 60px;
  color: #333333;
  position: absolute;
  left: 135px;
  top: 46px;
}

.en_con-23 {
  font-size: 40px;
  color: #333333;
  position: absolute;
  left: 135px;
  top: 46px;
}

.zh_con-24 {
  position: absolute;
  top: 63px;
  right: 140px;
}

.en_con-24 {
  position: absolute;
  top: 43px;
  right: 140px;
}

.con-25 {
  font-size: 22px;
}

.con-26 {
  /* height: 853px; */
  text-align: center;
  width: 100%;
}

.con-28 {
  font-size: 36px;
  color: #fff;
  position: absolute;
  top: 60px;
  left: 360px;
}

.con-29 {
  font-size: 22px;
  color: #fff;
  position: absolute;
  top: 137px;
  left: 360px;
}

.con-30 {
  display: flex;
  position: absolute;
  top: 99px;
  right: 360px;
}

.con-31 {
  width: 132px;
  height: 44px;
  border-radius: 4px;
  background-color: #4873FF;
  color: #fff;
  text-align: center;
  line-height: 44px;
  margin-right: 24px;
  font-size: 18px;
  cursor: pointer;

}

.con-32 {
  width: 132px;
  height: 44px;
  border-radius: 4px;
  background-color: #17152c;
  color: #4873FF;
  text-align: center;
  line-height: 44px;
  border: 1px solid #4873FF;
  font-size: 18px;
  cursor: pointer;

}

.con-33 {
  width: 86px;
  height: 86px;
  margin-bottom: 25px;
}

.con-34 {
  font-size: 18px;
  color: #333333;
  margin-bottom: 4px;
}

.con-35 {
  width: 21px;
  height: 3px;
  background-color: #17C17D;
  margin: 0 auto;
  margin-bottom: 16px;
}

.con-36 {
  font-size: 18px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-QRCode {
  height: 120px;
  width: 120px;
}

.QRCode {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.con-21-img {
  width: 40px;
  height: 40px;
}

.con-37 {
  width: 21px;
  height: 3px;
  background-color: #4873FF;
  margin: 0 auto;
  margin-bottom: 16px;
}

.btn-box {
  margin-top: 58px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.btn-blue {
  width: 132px;
  height: 44px;
  font-size: 18px;
  background-color: #4873FF;
  color: #fff;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  margin-right: 12px;
}

.btn-we {
  width: 132px;
  height: 44px;
  font-size: 18px;
  background-color: #fff;
  color: #4873FF;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  border: 1px solid #4873FF;
  margin-left: 12px;

}

.bg-1 {
  width: 1440px;
  height: 800px;
  margin-top: -25px;
  margin: 0 auto;
  z-index: -1;
  padding: 0 auto;
  margin-bottom: 292px;
  /* position: relative; */
}

.bg-img {
  width: 1400px;
  height: 800px;
  margin-top: 47px;

}

.bg-img-1 {
  width: 308px;
  height: 178px;
  position: absolute;
  top: 520px;
  left: -90px;
}

.bg-box-text {
  font-size: 22px;
  color: #333333;
  position: absolute;
  top: 610px;
  left: 20px;
  font-weight: 600;
}

.bg-2 {
  /* width: 100%; */
  height: 771px;
  z-index: -1;

}

.earth-box {
  position: relative;
}

.zh_text-font {
  color: #fff;
  font-weight: 500;
  font-size: 36px;
  position: absolute;
  top: 88px;
  left: 50%;
  transform: translateX(-50%)
}

.en_text-font {
  color: #fff;
  font-weight: 500;
  font-size: 36px;
  position: absolute;
  top: 88px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
}

.text-font-bottom {
  color: black;
  font-weight: 500;
  font-size: 36px;
  text-align: center;
  margin-top: 80px;
  color: #333333;
}



.bg-19 {
  width: 1388px;
  height: 550px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  border-top-left-radius: 1388px;
  border-top-right-radius: 1388px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  /* border: 1px solid #2A333B; */
  z-index: 9;
  box-sizing: border-box;
}

.bg-20 {
  width: 1570px;
  height: 550px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  /* border-top-left-radius: 70%;
  border-top-right-radius: 50%; */
  border: 1px solid #2A333B;
  z-index: 8;
}

.bg-img-2-container {
  position: absolute;
  top: 680px;
  left: 540px;
  width: 600px;
  height: 280px;
  overflow: hidden;
}

.bg-img-2 {
  width: 600px;
  height: 280px;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  animation: revealImage 5s linear infinite;
  animation-fill-mode: forwards;
}

@keyframes revealImage {

  0%,
  15% {
    clip-path: inset(0 90% 0 0);

  }

  15%,
  25% {
    clip-path: inset(0 80% 0 0);
  }

  25%,
  35% {
    clip-path: inset(0 70% 0 0);
  }

  35%,
  45% {
    clip-path: inset(0 60% 0 0);
  }

  45%,
  55% {
    clip-path: inset(0 50% 0 0);
  }

  55%,
  65% {
    clip-path: inset(0 40% 0 0);
  }

  65%,
  75% {
    clip-path: inset(0 30% 0 0);
  }

  75%,
  85% {
    clip-path: inset(0 20% 0 0);
  }

  85%,
  95% {
    clip-path: inset(0 10% 0 0);
  }

  95%,
  100% {
    clip-path: inset(0 100% 0 0);
  }
}

.bg-img-3-container {
  width: 470px;
  height: 500px;
  position: absolute;
  top: 700px;
  /* background:red; */
  right: 150px;
  z-index: 10;
  overflow: hidden;
  opacity: 0;
  transform: translateX(100%);
  animation: slideInFromRight 5s ease-in-out infinite;
}

.bg-img-3 {
  width: 460px;
  height: 500px;
  object-fit: cover;
}

@keyframes slideInFromRight {

  0%,
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }

  20%,
  80% {
    opacity: 1;
    transform: translateY(0);
  }
}

.img-box {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-img-text {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 18px;
  width: 116px;
  margin: 0 60px;
  cursor: pointer;

}

.con-1 {
  width: 22px;
  height: 22px;
}

.con-2 {
  width: 22px;
  height: 22px;
}

.con-3 {
  width: 21px;
  height: 21px;
}

.con-4 {
  width: 20px;
  height: 20px;
}

.con-5 {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}

.con-6 {
  font-size: 20px;
  line-height: 32px;
  color: #666666;
  margin: 15px 0 40px 0;
}

.con-7 {
  width: 20px;
  height: 20px;
}

.con-8 {
  margin-left: 8px;
  font-size: 20px;
  color: #333333;
}

.con-9 {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}

.con-10 {
  font-size: 16px;
  color: #666666;
  margin: 15px 0 40px 0;
}

.zh_box-img-1 {
  width: 680px;
  height: 436px;
}

.en_box-img-1 {
  width: 580px;
  height: 380px;
}

.zh_right-img {
  width: 680px;
  height: 436px;
}

.en_right-img {
  width: 580px;
  height: 380px;
}

.text-color {
  /* color:#666666; */
  margin-left: 10px;
  font-size: 20px;
  line-height: 60px;

}

.con-11 {
  position: relative;
  margin: 0 auto;
}

.con-12 {
  width: 58%;
}

.con-12-img {
  width: 843px;
  height: 918px;
  margin-left: 252px;
}


.con-13 {
  position: absolute;
  top: 326px;
  right: 351px;
  width: 467px;
}

.con-14 {
  color: #333333;
  font-size: 36px;
  font-weight: 600;
}

.con-15 {
  color: #666666;
  font-size: 22px;
  padding-top: 20px;
  line-height: 32px;
}

.zh_con-16 {
  height: 349px;
}

.en_con-16 {
  height: 400px;
}

.con-17 {
  position: absolute;
  top: 71px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 36px;
  color: #ffffff;
}

.con-18 {
  position: absolute;
  top: 153px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 22px;
  color: #ffffff;
}

.zh_con-19 {
  font-size: 60px;
  color: #333333;
  position: absolute;
  left: 135px;
  top: 46px;
}

.en_con-19 {
  font-size: 40px;
  color: #333333;
  position: absolute;
  left: 55px;
  top: 46px;
  text-align: center;
  /* width: 240px; */
}


.zh_con-20 {
  position: absolute;
  top: 76px;
  right: 120px;
}

.en_con-20 {
  position: absolute;
  top: 60px;
  right: 60px;
}

.con-20-img {
  width: 20px;
  height: 18px;
}

.actives {
  color: #4873FF !important;
  border-bottom: 4px solid #4873FF;
}

.zh_box548 {
  height: 548px;
  background-color: #F8F9FF;
  /* width: 100%; */
  position: relative;
  animation: fadeIn 1s;
}

.en_box548 {
  height: 660px;
  background-color: #F8F9FF;
  /* width: 100%; */
  position: relative;
  animation: fadeIn 1s;
}

.zh_text-boxs {
  width: 472px;
  padding-top: 93px;
  margin-left: 323px;
}

.en_text-boxs {
  width: 650px;
  padding-top: 93px;
  margin-left: 300px;
}


.yes-flex {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  color: #333333;
}

.zh_right-box {
  width: 690px;
  height: 436px;
  background-color: #F0F3FF;
  border-radius: 24px;
  position: absolute;
  top: 56px;
  right: 360px;
}

.en_right-box {
  width: 600px;
  height: 400px;
  background-color: #F0F3FF;
  border-radius: 24px;
  position: absolute;
  top: 60%;
  right: 10%;
  transform: translate(-10%, -60%);
}

.left-list {
  width: 260px;
  height: 270px;
  background-color: #fff;
  border-radius: 24px;
  position: absolute;
  top: 50px;
  left: 41px;
  box-shadow: 0px 0px 10px 1px #eef1fd;
  display: flex;
  justify-content: space-between;
}

.text-12,
.text-13 {
  position: absolute;
  left: 840px;
  font-size: 16px;
  z-index: 9999;
  color: #333;
  transition: transform 0.3s ease, color 0.3s ease;
  transform-origin: center;
  display: inline-block;
  /* 确保变换正常 */
}

.text-12.pulse-text,
.text-13.pulse-text {
  animation: text-pulse 1s ease-in-out forwards;
}

.typing-text.pulse-text {
  animation: text-pulse 1s ease-in-out forwards !important;
  display: inline-block;
  transform-origin: center;
}

@keyframes text-pulse {
  0% {
    transform: scale(1);
    color: #333;
  }

  0% {
    transform: scale(0.8);
    color: #333;
  }

  100% {
    transform: scale(1);
    color: #333;
  }
}

.text-12 {
  top: 393px;
}

.text-13 {
  top: 543px;
}

.typing-text {
  position: relative;
  display: inline-block;
}

.typing-text::after {
  content: '|';
  display: inline-block;
  margin-left: 2px;
  animation: blink 0.7s infinite;
}

@keyframes blink {

  0%,
  100% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

.left-list-text {
  color: #999999;
  font-size: 11px;
}

.right-list {
  width: 420px;
  height: 270px;
  background: #fff;
  border-radius: 24px;
  position: absolute;
  top: 117px;
  right: 39px;
  box-shadow: 0px 0px 10px 1px #eef1fd;
}

.img-icon-box {
  width: 500px;
  height: 400px;
  display: flex;
  /* justify-content: space-between; */
  /* background:red; */
  position: absolute;
  top: 940px;
  right: 50px;
  z-index: 110;
  /* opacity: 0;
  transform: translateX(100%);
  transition: opacity 1s ease, transform 1s ease; */

}

.img-icon-box1 {
  width: 500px;
  height: 400px;
  display: flex;
  position: absolute;
  top: 970px;
  right: 50px;
  z-index: 110;
}

.img-icon-box2 {
  width: 500px;
  height: 400px;
  display: flex;
  position: absolute;
  top: 1020px;
  right: 50px;
  z-index: 110;
}

.img-icon-box3 {
  width: 500px;
  height: 400px;
  display: flex;
  position: absolute;
  top: 1050px;
  right: 50px;
  z-index: 110;
}

.img-icon-box4 {
  width: 500px;
  height: 400px;
  display: flex;
  position: absolute;
  top: 1100px;
  right: 50px;
  z-index: 110;
}

.img-icon-box5 {
  width: 500px;
  height: 400px;
  display: flex;
  position: absolute;
  top: 1130px;
  right: 50px;
  z-index: 110;
}

.bg-img-icon:nth-child(1) {
  animation: iconReveal 5s ease-in-out infinite 0.2s;
}

.bg-img-icon1:nth-child(1) {
  animation: iconReveal 5s ease-in-out infinite 0.4s;
}

.bg-img-icon2:nth-child(1) {
  animation: iconReveal 5s ease-in-out infinite 0.6s;
}

.bg-img-icon3:nth-child(1) {
  animation: iconReveal 5s ease-in-out infinite 0.8s;
}

.bg-img-icon4:nth-child(1) {
  animation: iconReveal 5s ease-in-out infinite 1s;
}

.bg-img-icon5:nth-child(1) {
  animation: iconReveal 5s ease-in-out infinite 1.2s;
}

/* .bg-img-icon:nth-child(2) { animation: iconReveal 5s ease-in-out infinite 0.4s; }
.bg-img-icon:nth-child(3) { animation: iconReveal 5s ease-in-out infinite 0.6s; }
.bg-img-icon:nth-child(4) { animation: iconReveal 5s ease-in-out infinite 0.8s; }
.bg-img-icon:nth-child(5) { animation: iconReveal 5s ease-in-out infinite 1s; }
.bg-img-icon:nth-child(6) { animation: iconReveal 5s ease-in-out infinite 1.2s; } */
@keyframes iconReveal {

  0%,
  20% {
    opacity: 0;
    transform: translateY(-100%);
  }

  30%,
  70% {
    opacity: 1;
    transform: translateY(0);
  }

  80%,
  100% {
    opacity: 0;
    transform: translateY(100%);
  }
}

.bg-img-icon {
  /* position:absolute; */
  width: 80px;
  height: 16px;
  /* margin-left:15px; */
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.bg-img-icon1 {
  width: 320px;
  height: 30px;
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.bg-img-icon2 {
  width: 40px;
  height: 16px;
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.bg-img-icon3 {
  width: 320px;
  height: 30px;
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.bg-img-icon4 {
  width: 80px;
  height: 16px;
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.bg-img-icon5 {
  width: 320px;
  height: 30px;
  opacity: 0;
  transform: translateX(-100%);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

@keyframes revealImageFromRight {

  0%,
  15% {
    clip-path: inset(0 0 0 100%);
  }

  15%,
  25% {
    clip-path: inset(0 0 0 80%);
  }

  25%,
  35% {
    clip-path: inset(0 0 0 60%);
  }

  35%,
  45% {
    clip-path: inset(0 0 0 40%);
  }

  45%,
  55% {
    clip-path: inset(0 0 0 20%);
  }

  55%,
  75% {
    clip-path: inset(0 0 0 0%);
  }

  75%,
  90% {
    clip-path: inset(0 0 0 0%);
    opacity: 1;
  }

  90%,
  100% {
    clip-path: inset(0 0 0 100%);
    opacity: 0;
  }
}

.title {
  width: 382px;
  height: 37px;
  background-color: #F4F7FC;
  margin: 22px 20px 17px 17px;
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.title-text-right {
  color: #999999;
  font-size: 11px;
}

@keyframes slide-in {
  0% {
    transform: translateX(200%) scale(0.5) rotate(45deg);
    opacity: 0;
  }

  100% {
    transform: translateX(0) scale(1) rotate(0deg);
    opacity: 1;
  }
}

@keyframes subtle-bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.bg-img-4 {
  width: 65px;
  height: 65px;
  position: absolute;
  top: 577px;
  left: 970px;
  /* 初始位置在屏幕右侧 */
  z-index: 15;
  opacity: 0;
  animation:
    slide-in 1.5s cubic-bezier(0.25, 0.1, 0.25, 1) forwards,
    subtle-bounce 0.5s ease-in-out 1.5s;
}

.bg-img-4.show-slide {
  width: 65px;
  height: 65px;
  position: absolute;
  top: 577px;
  left: 1070px;
  /* 最终位置 */
  opacity: 1;
}

.zh_bg-img-5 {
  width: 50px;
  height: 14px;
  position: absolute;
  top: 450px;
  left: 868px;
  z-index: 15;
  opacity: 0;
  opacity: 0;
  animation: fadeIn 2s forwards;
}

.en_bg-img-5 {
  width: 50px;
  height: 14px;
  position: absolute;
  top: 450px;
  left: 910px;
  z-index: 15;
  opacity: 0;
  opacity: 0;
  animation: fadeIn 2s forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.bg-img-5.show-slide {
  width: 30px;
  height: 14px;
  position: absolute;
  top: 450px;
  left: 868px;
  /* 最终位置 */
  opacity: 1;
}

.min-left-box {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 307px;
  left: 127px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 1px #eef1fd;
}

.min-right-box {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 79px;
  right: 65px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 1px #eef1fd;

}

.linBox-res {
  display: flex;
  justify-content: center;
  margin-top: -100px;
  margin-bottom: 91px;
}

.linBox {
  width: 371px;
  height: 243px;
  border-radius: 24px;
  background: linear-gradient(to top, #ffffff, #E0E7FF);
  border: 1px solid #E0E7FF;
}

.linBox1 {
  width: 371px;
  height: 243px;
  border-radius: 24px;
  background: linear-gradient(to top, #ffffff, #E0E7FF);
  border: 1px solid #E0E7FF;
  margin: 0 44px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  position: relative;
}

.bottom-box {
  margin-top: 100px;
  margin-bottom: 87px;
}

.bottom-min-box {
  width: 1169px;
  height: 285px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.zh_bottom-left-box {
  padding-top: 58px;
  padding-bottom: 85px;
  width: 323px;
}

.en_bottom-left-box {
  padding-top: 58px;
  padding-bottom: 85px;
  width: 380px;
}

.bottom-text-36 {
  font-size: 36px;
  color: #333333;
  font-weight: 400;
}

.bottom-text-18 {
  font-size: 22px;
  color: #666666;
  margin-top: 30px;
  line-height: 32px;
}

.bottom-right-box {
  display: flex;
}

.box-wx {
  width: 260px;
  height: 300px;
  border-top-left-radius: 40px;
  border-bottom-right-radius: 40px;
  box-shadow: 0px 4px 24px 0px #EBEFFA;
  border-bottom-left-radius: 2px;
  border-top-right-radius: 2px;
  margin-right: 30px;
  padding-top: 44px;
  text-align: center;
  cursor: pointer;
}

.box-app {
  width: 300px;
  height: 300px;
  border-top-left-radius: 40px;
  border-bottom-right-radius: 40px;
  box-shadow: 0px 4px 24px 0px #EBEFFA;
  border-bottom-left-radius: 2px;
  border-top-right-radius: 2px;
  margin-right: 30px;
  padding-top: 44px;
  text-align: center;
  cursor: pointer;
  margin-left: 41px;
}

.box-ml {
  width: 300px;
  height: 300px;
  border-top-left-radius: 40px;
  border-bottom-right-radius: 40px;
  box-shadow: 0px 4px 24px 0px #EBEFFA;
  border-bottom-left-radius: 2px;
  border-top-right-radius: 2px;
  padding-top: 44px;
  text-align: center;
  cursor: pointer;

}

.bottom-Filmny {
  height: 320px;
  background-color: #F8F9FF;
  padding-top: 87px;
}

.bottom-Filmny-box {
  width: 1169px;
  margin: 0 auto;
  height: 255px;
  display: flex;
  justify-content: space-between;
}


.Filmny-right {
  display: flex;

}

.Filmny-text-3 {
  font-size: 20px;
  color: #333333;
  font-weight: 600;
}

.Filmny-text-6 {
  font-size: 16px;
  color: #666666;
  margin-top: 16px;
}

@keyframes click-pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.4);
  }

  50% {
    transform: scale(0.9);
    box-shadow: 0 0 0 10px rgba(0, 123, 255, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
  }
}


@keyframes fade-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

.bg-10.fade-out-animation {
  animation:
    fade-out 0.8s ease-out forwards;
}

.new-white-box {
  position: absolute;
  top: 281px;
  left: 740px;
  width: 380px;
  height: 340px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.8s ease-out;
}

.new-white-box.show {
  opacity: 1;
  transform: scale(1);
}

.bg-9.pulse-animate,
.bg-10.pulse-animate {
  animation:
    click-pulse 1s ease-in-out forwards;
}

.bg-10 {
  position: absolute;
  top: 281px;
  left: 740px;
  ;
  width: 400px;
  height: 398px;
  z-index: 10;
  margin-top: -25px;
  transition: transform 0.3s ease;
  transform-origin: center;
}

.bg-9 {
  width: 165px;
  height: 36px;
  position: absolute;
  top: 590px;
  left: 850px;
  z-index: 10;
  transition: transform 0.3s ease;
  transform-origin: center;
}

.bg-img-6 {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 60px;
  left: 160px;
}

.bg-img-7 {
  width: 40px;
  height: 35px;
  position: absolute;
  top: 70px;
  left: 170px;
}

.bg-img-8 {
  width: 180px;
  height: 40px;
  position: absolute;
  top: 230px;
  left: 100px;
}

.white_text {
  font-size: 16px;
  color: #333333;
  position: absolute;
  top: 130px;
}

.en_white_text {
  left: 125px;
}

.zh_white_text {
  left: 155px;
}


.white_number {
  font-size: 19px;
  position: absolute;
  top: 160px;
  left: 142px;
}

@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-left-to-right {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.new-white-box {
  /* 现有样式保持不变 */
  overflow: hidden;
}

.bg-img-6,
.bg-img-7,
.white_text,
.white_number,
.bg-img-8 {
  opacity: 0;
}

.new-white-box.show .bg-img-6 {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 0.2s;
}

.new-white-box.show .bg-img-7 {
  animation: slide-left-to-right 0.8s ease-out forwards;
  animation-delay: 0.6s;
}

.new-white-box.show .white_text {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 0.8s;
}

.new-white-box.show .white_number {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 1s;
}

.new-white-box.show .bg-img-8 {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 1.2s;
}

@keyframes slide-left {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50px);
  }
}

@keyframes box-fade-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

.bg-img-9 {
  width: 65px;
  height: 65px;
  position: absolute;
  top: 220px;
  left: 220px;
  z-index: 15;
  transition: transform 1s ease-in-out;
}

.new-white-box.slide-and-fade .bg-img-9 {
  animation: slide-left 1s ease-in-out forwards;
}

.new-white-box.slide-and-fade {
  animation:
    box-fade-out 0.8s ease-in-out 0.8s forwards;
}
</style>